<lib-menu-container [menuItems]="menuItems$"></lib-menu-container>
